import { Box, Skeleton } from "@mui/material";

interface IVirtuosoFooterProps {
  isFetching: boolean;
}

export const VirtuosoFooter = (props: IVirtuosoFooterProps) => {
  const { isFetching } = props;
  if (!isFetching) return null;

  return (
    <Box sx={{ px: 2, py: 1.5 }}>
      <Skeleton variant="rounded" width="100%" height={56} />
    </Box>
  );
};
